import { render } from "./Challenge.vue?vue&type=template&id=77b38007&ts=true"
import script from "./Challenge.vue?vue&type=script&lang=ts"
export * from "./Challenge.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__